const Emoji_F = {
    ':fart': { id: 227, width: 18, height: 29 },
    ':fartnew': { id: 229, width: 18, height: 29 },
    ':fartnew2': { id: 228, width: 46, height: 29 },
    ':fear_1': { id: 230, width: 18, height: 18 },
    ':fear': { id: 232, width: 25, height: 25 },
    ':fear2': { id: 231, width: 20, height: 21 },
    ':fibber': { id: 594, width: 18, height: 18 },
    ':figa': { id: 233, width: 20, height: 20 },
    ':fingal': { id: 234, width: 22, height: 15 },
    ':fireman_1': { id: 235, width: 25, height: 25 },
    ':fireman': { id: 236, width: 25, height: 25 },
    ':flag_austria': { id: 237, width: 45, height: 25 },
    ':flag_french': { id: 238, width: 45, height: 25 },
    ':flag_germany': { id: 239, width: 45, height: 25 },
    ':flag_schweiz': { id: 240, width: 45, height: 25 },
    ':flipoff': { id: 59, width: 18, height: 18 },
    ':flower': { id: 611, width: 18, height: 18 },
    ':flowers': { id: 587, width: 28, height: 18 },
    ':flush': { id: 242, width: 24, height: 26 },
    ':football': { id: 243, width: 23, height: 28 },
    ':footinmouth': { id: 244, width: 21, height: 19 },
    ':foyer': { id: 245, width: 19, height: 19 },
    ':fredy': { id: 246, width: 34, height: 27 },
    ':frown': { id: 247, width: 16, height: 16 },
    ':fruits_apple': { id: 248, width: 18, height: 29 },
    ':fruits_cherry': { id: 249, width: 18, height: 19 },
    ':fruits_orange': { id: 250, width: 18, height: 18 },
    ':frusty': { id: 251, width: 30, height: 17 },
    ':fullmop': { id: 252, width: 20, height: 19 },
    ':funny': { id: 8, width: 18, height: 18 },
    ':furious': { id: 253, width: 18, height: 18 },
    ':fuyou_1': { id: 254, width: 25, height: 20 },
    ':fuyou_2': { id: 255, width: 25, height: 20 },
    ':fyou': { id: 256, width: 25, height: 20 },
}

export default Emoji_F
